import { useContext } from "react";
import SentimentDrivers from "../SentimentDriver/SentimentDriver";
import BrandSummary from "../BrandSummary/BrandSummary";
import { DiscoveryContext, useIsSelectedSection } from "../discovery-context";
import AttributesOverview from "../Attributes/AttributesOverview";
import SourcesOverview from "../Sources/sourcesOverview";
import FocusAreaOverView from "../FocusArea/focusArea";
import MUISelect from "../../../Component/UI/MUISelect/MUISelect";
import classes from "./BrandOverview.module.css";
import { LLM_OPTIONS } from "../../../utils/constant";
import { tab } from "../BrandScore/BrandScore";
import Checkbox from "@mui/material/Checkbox";

export default function BrandOverview() {
  const discoveryCtx = useContext(DiscoveryContext);
  const id = "Sentiment_Drivers";
    const { checked, uniqueKey } = useIsSelectedSection({ id,tab:tab.competitiveOverview });
  return (
    <div className={classes.containerWrapper}>
      <BrandSummary />
      <div className={classes.headerWrapper}>
        <div style={{display:'flex' ,gap:'2', alignItems:'center'}}>
        <h5 className={classes.heading}>Sentiment Drivers</h5>
        {discoveryCtx.state.showReportCheckbox && (
                        <Checkbox
                          checked={checked}
                          onChange={() => {
                            discoveryCtx?.clickComponentCheckbox({
                              uniqueKey,
                              filter: {
                                id: id,
                                title: "Sentiment Driver",
                                tab: tab.brandOverview,
                                uniqueKey
                              },
                              checked,
                              id,
                            });
                          }}
                          inputProps={{ "aria-label": "controlled" }}
                        />
                      )}
                              </div>

        <div className={classes.dropdownWrapper}>

          <MUISelect
            fullWidth={false}
            optionValue={discoveryCtx.state.selectedLLM}
            label={"LLM"}
            options={(discoveryCtx.llm || []).map((llm) => {
              const match = LLM_OPTIONS.find((option) => option.value === llm);
              return {
                name: match ? match.name : llm,
                value: llm,
              };
            })}
            onChange={(e) => {
              discoveryCtx.updateSelectedLLM(e.target.value);
            }}
          />
          <MUISelect
            fullWidth={false}
            optionValue={discoveryCtx.state.selectedCategory}
            label={"Category"}
            options={(discoveryCtx.category || []).map((category) => {
              return {
                name: category,
                value: category,
              };
            })}
            onChange={(e) => {
              discoveryCtx.updateSelectedCategory(e.target.value);
            }}
          />

        </div>
      </div>
      <SentimentDrivers
        isSelectedMarket={true}
        id={id}
      />

      <AttributesOverview />
      <SourcesOverview />
      <FocusAreaOverView />
    </div>
  );
}
